import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Card, CardContent, CardMedia, Typography, IconButton, Button } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'react-router-dom';
import productsData from '../jsons/products.json';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const ProductCarousel = ({ heading, headingStyle }) => {
  const imageStyle = {
    width: '100%',
    height: '200px', // Adjust the height as needed
    objectFit: 'contain',
    borderRadius: '8px',
    transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
  };

  const cardStyle = {
    position: 'relative',
    overflow: 'hidden',
    '&:hover::before': {
      content: '""',
      position: 'absolute',
      top: '3px',
      left: '20px',
      right: '20px',
      bottom: '146px',
      backgroundColor: '#ADD8E6',
      zIndex: 0,
      borderRadius: '8px',
    },
    '& img': {
      position: 'relative',
      zIndex: 1,
      transition: 'transform 0.3s ease-in-out',
    },
    '&:hover img': {
      transform: 'scale(1.05)',
    },
    '&:hover': {
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Add shadow on hover
    },
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <Typography variant="h5" component="h2" sx={headingStyle} style={{ marginLeft: '10px' }}>
          {heading}
        </Typography>
        <Button component={Link} to="/all-products" variant="outlined" color="primary">
          View All
        </Button>
      </div>
      <Carousel
        swipeable={false}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={true}
        infinite={true}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={['tablet', 'mobile']}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item"
        renderButtonGroupOutside={true}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <IconButton
              aria-label="previous"
              className="carousel-arrow carousel-arrow-prev"
              onClick={onClickHandler}
              style={{ left: '10px' }}
            >
              <NavigateBeforeIcon />
            </IconButton>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <IconButton
              aria-label="next"
              className="carousel-arrow carousel-arrow-next"
              onClick={onClickHandler}
              style={{ right: '10px' }}
            >
              <NavigateNextIcon />
            </IconButton>
          )
        }
      >
        {productsData.map((product, index) => (
          <Link key={index} to={`/products/${product.id}`} style={{ textDecoration: 'none', height: '100%' }}>
            <Card sx={{ maxWidth: 345, height: 350, border: '1px solid #ccc', m: 1, py: 2, borderBottom: '1px solid #ccc', display: 'flex', flexDirection: 'column', ...cardStyle }}>
              <CardMedia
                component="img"
                height="200"
                width="100%"
                image={product.imgSrc}
                alt={product.title}
                sx={{ ...imageStyle }}
              />
              <CardContent sx={{ flex: '1 0 auto' }}>
                <Typography gutterBottom variant="h6" component="div" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                  {product.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {product.author}
                </Typography>
                <div style={{ display: 'flex', gap: "10px", marginTop: 'auto' }}>
                  <Typography variant="body2">
                    ₹{product.price}
                  </Typography>
                  {product.oldPrice && (
                    <Typography variant="body2" color="text.secondary">
                      <s>₹{product.oldPrice}</s>
                    </Typography>
                  )}
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </Carousel>
    </div>
  );
};

export default ProductCarousel;
